import { endpoints, request } from '!core/api';

export const webAreasServices = {
  webAreas: ({ webPage }) =>
    request.get(endpoints.chnn(`WsbGetWebAreas?webPage=${webPage}`)),
  webAreaInstrQuotes: ({ account, webPage, webArea }) =>
    request.get(
      endpoints.chnn(
        `wsbGetWebAreaInstrQuotes?account=${account}&webPage=${webPage}&webArea=${webArea}`,
      ),
    ),
  webAreaGraphQuotes: ({ account, webPage, webArea }) =>
    request.get(
      endpoints.chnn(
        `wsbGetWebAreaGraphQuotes?account=${account}&webPage=${webPage}&webArea=${webArea}`,
      ),
    ),
};
